import './Header.scss'

import React from 'react'
import { FormattedMessage } from 'react-intl'

// Material-ui Components
import { Button, makeStyles } from '@material-ui/core'
import { features } from '../../utils/featureFlags'

interface NavLinksProps {
  isLoggedIn: boolean
  isAdmin: boolean
  isSuperuser: boolean
  pendingOars: number
  pendingDrafts: number
  toMainPage: () => void
  toSearchPage: () => void
  toHelpPage: () => void
  toUserInformationPage: () => void
  toUserManagementPage: () => void
  toModerationPage: () => void
}

export const NavLinks = ({
  isLoggedIn,
  isAdmin,
  isSuperuser,
  pendingOars,
  pendingDrafts,
  toMainPage,
  toSearchPage,
  toHelpPage,
  toUserInformationPage,
  toUserManagementPage,
  toModerationPage,
}: NavLinksProps): React.ReactElement => {
  const isPrivilegedUser = isAdmin || isSuperuser

  const moderationStyles = (pending: number) =>
    isPrivilegedUser &&
    makeStyles((theme) => ({
      root: {
        color: theme.palette.primary.main,
        ...(pending > 0
          ? {
              '&::after': {
                content: `"${pending > 9 ? '9+' : pending.toString()}"`,
                justifyContent: 'center',
                width: '25px',
                height: '25px',
                top: '2px',
                right: '2px',
                position: 'absolute',
                borderRadius: '50%',
                display: 'flex',
                flexDirection: 'column',
                alignContent: 'center',
                color: 'white',
                backgroundColor: '#bd2719',
              },
            }
          : {}),
      },
    }))()

  return (
    <React.Fragment>
      <Button onClick={toMainPage}>
        <FormattedMessage id="events-management" />
      </Button>
      <Button onClick={toSearchPage}>
        <FormattedMessage id="search-events" />
      </Button>
      <Button onClick={toHelpPage}>
        {' '}
        <FormattedMessage id="more-info" />
      </Button>
      {features.userManagement && isLoggedIn && (
        <Button onClick={toUserInformationPage}>
          {' '}
          <FormattedMessage id="user-info-page" />
        </Button>
      )}
      {features.userManagement && isSuperuser && (
        <Button
          onClick={toUserManagementPage}
          classes={moderationStyles(pendingOars) || undefined}
        >
          <FormattedMessage id="user-management-page" />
        </Button>
      )}
      {isPrivilegedUser && (
        <Button
          onClick={toModerationPage}
          classes={moderationStyles(pendingDrafts) || undefined}
        >
          <FormattedMessage id="moderation-page" />
        </Button>
      )}
    </React.Fragment>
  )
}
